/*
 * ATN custom — thumbnail gallery arrows
 * Pages the 2-row thumbnail carousel (carousel-slider.thumbnails--2row) left/right,
 * mimicking the production Owl-carousel behavior. Vanilla JS — no jQuery dependency
 * (the Symmetry theme does not load jQuery). Paired with .thumbnails--2row rules in atk-theme.css.
 */
(function () {
  function initThumbNav(wrap) {
    var slider = wrap.querySelector('.slider');
    var prev = wrap.querySelector('.thumbnails-nav__prev');
    var next = wrap.querySelector('.thumbnails-nav__next');
    if (!slider || !prev || !next) return;

    function page(dir) {
      /* scroll ~90% of the visible width so a little context carries over */
      slider.scrollBy({ left: dir * slider.clientWidth * 0.9, behavior: 'smooth' });
    }

    function updateButtons() {
      var max = slider.scrollWidth - slider.clientWidth - 2; /* -2 for rounding */
      prev.disabled = slider.scrollLeft <= 0;
      next.disabled = slider.scrollLeft >= max;
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); page(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); page(1); });
    slider.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);

    updateButtons();
  }

  function init() {
    var carousels = document.querySelectorAll('carousel-slider.thumbnails--2row');
    for (var i = 0; i < carousels.length; i++) initThumbNav(carousels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
